import { QueryFunction, QueryKey } from "@tanstack/react-query"
import { handleResponse } from "./handleResponse.ts"

export const defaultQueryFn: QueryFunction<unknown, QueryKey, never> = async ({ queryKey, signal }) => {
    const [endpoint, params] = queryKey as [string, string | Record<string, string> | undefined]

    let searchParams = ''

    if (params) {
        searchParams = typeof params === 'string' ?
            params : new URLSearchParams(params as Record<string, string>).toString()
    }

    const url = searchParams ?
        `${endpoint.startsWith('/public/') ? '' : '/api/'}${endpoint}?${searchParams}` :
        `${endpoint.startsWith('/public/') ? '' : '/api/'}${endpoint}`

    return handleResponse(await fetch(url, { signal, credentials: 'include', mode: 'same-origin' }))
}
